module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-5-b42ed3951415e7763e54b20662c49be1.jpg";